// JavaScript Document
import React from "react";

export const translations = {
    en: {
        login: 'Log in',
        logout: 'LOGOUT',
        password: 'password',
        password_forgotten: 'Forgot your password?',
        forgotten_password: 'Forgotten password',
        reset_success: 'Your password was reset',
        resend_password: 'Resend Password',
        keep_me: 'Keep me logged in',
        click_here: 'Click here.',

        provide_email_and_password: 'Please provide e-mail and password.',
        provide_email: 'Please provide e-mail.',
        provide_password: 'Please provide password.',
        provide_valid_email: 'Please provide valid e-mail.',
        invalid_username_password: 'Invalid username and password combination.',
        invalid_user_credentials: 'Invalid user credentials',

        emailCourier: 'E-mail',
        email: 'E-mail',
        Email: 'E-mail',
        check_email: 'Check your email in a few minutes for a recovery link.',
        enter_email: 'Enter email',
        send: 'Send',
        resend: 'Resend',
        cancel: 'Cancel',
        delete: 'Delete',
        HELP: 'HELP',
        Save: 'Save',

        Role: 'Role',
        role_select_placeholder: 'Select owner, manager or employee',
        ADMIN: 'Site Admin',
        ROLE_OWNER: 'Store Owner',
        ROLE_MANAGER: 'Pharmacy Manager',
        ROLE_PHARMACIST: 'Pharmacist',

        USER: 'USER',
        Users: 'Users',
        users_description: 'Add new users or edit the users list and permissions.',
        user_info: 'User info',
        Add_new_user: 'Add new user',

        Company: 'Company',
        Companies: 'Companies',
        companies_description: 'Add new company or edit the list of companies.',
        add_company: 'Add Company',
        add_new_company: 'Add new company',
        create_company: 'Create Company',
        save_company: 'Save Company',
        edit_company: 'Edit Company',
        select_company: 'Select company',
        company_info: 'Company info',
        company_name: 'Company Name',
        company_owner: 'Company Owner',
        select_company_owner: 'Select Company Owner',

        Pharmacy: 'Pharmacy',
        Pharmacies: 'Pharmacies',
        Pharmacy_name: 'Pharmacy name',
        Pharmacy_info: 'Pharmacy info',
        Pharmacy_description: 'Add, edit or delete any of your Pharmacy. Customize design and  services.',
        Add_Pharmacy: 'Add Pharmacy',
        Add_new_pharmacy: 'Add new pharmacy',
        Edit_pharmacy: 'Edit pharmacy',
        Enter_pharmacy_name: 'Enter pharmacy name',
        Select_pharmacy: 'Select pharmacy',
        pharmacy_manager: 'Pharmacy Manager',
        select_pharmacy_manager: 'Select Pharmacy Manager',
        pharmacies_owned: 'Pharmacies Owned',
        pharmacy_count: 'Pharmacy count',

        Services: 'Services',
        Add_Services: 'Add Services',
        Add_pharmacy_service: 'Add pharmacy service',
        Edit_pharmacy_service: 'Edit pharmacy service',
        Add_service_name: 'Add service name',
        Add_service_name_placeholder: 'Enter service name for the list view',
        Add_service_title: 'Add service title',
        Service_title: 'Service title',
        Service_description: 'Service description',
        service_language: 'Service Language',
        service_language_placeholder: 'Select service language',

        Link_to_iFrame: 'Link to iFrame',
        Link_to_iFrame_placeholder: 'This is the link to your iFrame (optional)',
        Link_to_service: 'Link to service',
        Link_to_service_placeholder: 'This is the link to your page (optional)',

        Name: 'Name',
        nameCourier: 'Name',
        name: 'Name',
        address: 'Address',
        City: 'City',
        phone: 'Phone',
        phone_number: 'Phone number',
        Category: 'Category',
        insurance_card: 'Insurance card',
        insuranceCard: 'Insurance card',
        insuranceCardCourier: 'Insurance card',
        Insurance_card: 'Insurance card (optional)',
        Second_insurance_card: 'Second insurance card (optional)',
        insurance_card_photos: 'Insurance card photos',
        second_insurance_card_photos: 'Second insurance card photos',
        insurance_card_images: 'Insurance cards images',
        no_insurance_card_info: 'no insurance card info',
        Primary_card: 'Primary card number',
        Secondary_card: 'Secondary card number',
        web_address: 'Web Address',
        web_site_placeholder: 'Enter web address',
        instruction_url: 'Instruction URL',
        instruction_url_placeholder: 'Enter instruction url',
        Drugstore: 'Drugstore',
        primary_info: 'Primary Information',
        design: 'Design',
        offering: 'Offering',
        delivery_option: 'Delivery Option',
        contact: 'Contact',

        Order: 'Order',
        Orders: 'Orders',
        All_Orders: 'All Orders',
        Orders_description: 'Edit or delete any of your Orders.',
        Orders_email: 'Orders email',
        Orders_subscription: 'Send orders to all employees.',
        order_number: 'Order Number',
        order_address: 'Order address',
        order_status: 'Orders Status',
        Pending_Orders: 'Pending Orders',
        pending_order: 'Pending Order',
        Accepted_Orders: 'Accepted Orders',
        accept_order: 'Accept Order',
        Active_Orders: 'Active Orders',
        Ready_Orders: 'Ready Orders',
        order_ready: 'Order Ready',
        Canceled_Orders: 'Canceled Orders',
        cancel_order: 'Cancel Order',
        delete_order: 'Delete Order',
        Closed_Orders: 'Closed Orders',
        orders_delivered: 'Orders Delivered',

        Patients: 'Patients',
        Patients_description: 'List, create, edit patients.',

        Statistics: 'Statistics',
        Statistics_description: 'See how each pharmacy is performing. How many requests they have, and how long does it takes to deliver.',
        Response_Time: 'Response Time',
        Filter_by_status: 'Filter by status',

        owner: 'Owner',
        employees: 'Employees',
        Manager: 'Manager',

        Add_description: 'Add description',
        Add_picture: 'Add picture',
        Learn_more: 'Learn more',
        see_details: 'see details',
        view_images: 'view images',
        preview_image: 'preview image',
        show_per_page: 'Show {num} per page',
        first: 'first',
        last: 'last',
        back: 'Back',
        reset: 'reset',
        yes: 'Yes',
        no: 'No',
        Photos: 'Photos',
        front_side: 'Front side',
        back_side: 'Back side',
        image_front: 'front',
        image_back: 'back',
        choose_search_criteria: 'Choose search criteria to add customer',
        search_by_name: 'Seacrh by name',
        search_post_code_address: 'Search by Name, Post code or Street address',
        search_by_email: 'Seacrh by e-mail',
        search_by_insurance_card: 'Seacrh by insurance card',
        no_results_found: 'No results found',
        something_went_wrong: 'Something went wrong!',
        error: 'error',
        not_empty_error: 'This input should no be empty.',
        add: 'Add',
        not_set: 'Not set.',
        active: 'Active',

        no_email_set: 'No email set.',
        no_owner_set: 'No owner set.',
        enter_valid_address: 'Please enter valid address.',
        mailing_purposes_only: 'This is for mailing purposes if needed.',
        search_places: 'Start writing and choose from the list.',
        select_address_from_suggest_list: 'Please select address from suggest list.',
        select_address_from_suggest_list_edit: 'If you want to edit your address select from suggest list',
        work_phone: 'Work Phone',

        client_name: 'Client Name',
        date_received: 'Date Received',
        date_completed: 'Date Completed',
        registered_on: 'Registered On',

        medication: 'Medication',
        medication_name: 'Medication name',
        quantity: 'Qty.',
        amount_label: 'Amount',
        price_label: 'Price',
        subtotal_label: 'Subtotal',
        quantity_label: 'Quantity',
        package_size_label: 'Package size',
        package_type: 'Package type',
        package_size: 'Package size',
        box: 'Box',
        blister: 'Blister',
        bottle: 'Bottle',
        sachet: 'Sachet',
        ampoule: 'Ampoule',
        pack: 'Pack',
        Notes: 'Notes',
        Pharmacist: 'Pharmacist',
        Druggist: 'Druggist',
        Received: 'Received',
        Read: 'Read',
        Taken: 'Taken',
        Sent: 'Sent',
        on: 'on',
        write_a_msg: 'Write a message the customer will receive.',
        change_status: 'Change status',
        change_status_to: 'Chnage status to: ',
        delete_order_msg: 'Are you sure you want to delete this order?',
        delete_order_info: 'Order status must be Ready or Cancelled to be able to delete the order.',
        order_is_deleted: 'Order is deleted',

        insurance_card_warning_1: 'This value must start with "8075".',
        insurance_card_warning_2: 'This value must start with "8075" and have exactly 20 digits.',
        insurance_card_warning_3: 'This value should have exactly 20 digits.',
        please_select_a_date: 'Please select a date.',

        Shop: 'Shop',
        Shop_url: 'Shop url',
        shop_input_placeholder: 'Enter a valid link to your shop.',
        Save_shop_url: 'Save shop url',

        Merchant_id: 'Merchant Id',
        Merchant_id_input_placeholder: 'Enter a valid Merchant Id.',

        Edit_payment: 'Edit Payment',
        Save_edit_payment: 'Save',

        Public_key: 'Public Key',
        Public_key_input_placeholder: 'Enter a valid link to your Public Key.',

        Private_key: 'Private Key',
        Private_key_input_placeholder: 'Enter a valid Private Key.',

        Background: 'Background',
        Backdrop: 'Backdrop Color',
        Optimal_size: 'Optimal image size is {width}x{height} px.',
        use_png: 'Please use .png or .jpeg',
        Logo: 'Logo',
        Text_color: 'Text color',
        Opacity: 'Backdrop Opacity',
        Scale: 'Logo Scale',
        Gradient: 'Background Gradient',
        Solid: 'Solid',
        Opening_hours_today: 'Opening hours today',
        to: 'to',
        and: 'and',
        My_medications: 'My medications',
        Contacts: 'Contacts',

        Work_time_editor: 'Work time editor',
        Work_time: 'Work time today',
        Work_time_language: 'Work time language',
        Day: 'Day',
        Add_date: 'Add date',
        Date: 'Date',
        Work_from: 'Work from',
        Work_to: 'Work to',
        Day_Off: 'Day Off',
        monday: 'monday',
        tuesday: 'tuesday',
        wednesday: 'wednesday',
        thursday: 'thursday',
        friday: 'friday',
        saturday: 'saturday',
        sunday: 'sunday',
        areas_of_delivery_time: 'Areas of delivery and delivery times',
        separate_areas_with_comma: 'Separate areas with comma',
        Lunch_Break: 'Lunch Break',
        Special_work_time: 'Special work time',
        work_time_tab: 'Work time',
        special_days_tab: 'Special days',
        national_holidays_tab: 'National holidays',
        holiday: 'Holiday',
        enter_name: 'Enter name (optional)',
        Pick_a_date: 'Pick a date',
        areas_of_delivery_text_en: 'Our pharmacy delivers in standard work time and in the entire city.',
        areas_of_delivery_text_de: 'Unser Apotheke bietet den Hauslieferdienst in der ganzen Stadt an.',
        areas_of_delivery_text_fr: 'Notre pharmacie livre dans toute la localité, durant les heures d\'ouverture.',
        areas_of_delivery_text_it: 'Our pharmacy delivers in standard work time and in the entire city.',

        disable_home_delivery: 'Disable Home delivery.',
        has_services: 'Has Services',
        disable_delivery_by_courier: 'Disable delivery by courier.',
        customer_white_list_editor: 'Customer white list editor',
        customer_white_list: 'Delivery white list',
        change_white_list_warning: 'Changes will take effect immediately. Do you want to continue?',
        
        customer_white_list_courier_editor: 'Customer white list courier editor',
        customer_white_list_courier: 'Courier white list',
        change_white_list_courier_warning: 'Changes will take effect immediately. Do you want to continue?',

        Add_user: 'Add user',
        Save_user: 'Save user',
        Edit_User: 'Edit User',
        Edit_Password: 'Edit Password',
        User_Full_name: 'User Full name',
        user_email_placeholder: 'This is just for verification and login',

        Add_new_patient: 'Add new patient',
        Create_patient: 'Create patient',
        Edit_patient: 'Edit patient',
        edit_patient: 'Edit patient',
        delete_patient: 'Delete patient',
        Patient_info: 'Patient info',
        Birthday: 'Birthday',
        print_QR_code: 'Print QR code',
        generate_QR_code: 'Generate QR CODE',
        scan_QR_code: 'Scan QR code',
        patient_name: 'Patient name',
        patient_name_placeholder: 'Patient name',
        patient_birthday_placeholder: 'Choose or write date (e.g. 14/05/1992)',
        patient_insurance_card: 'Primary insurance card number',
        patient_insurance_card_2: 'Secondary insurance card number',
        patient_insurance_card_placeholder: 'Enter card number start with "8075" and include 20 digits.',
        patient_insurance_card_2_placeholder: 'Enter card 2 number start with "8075" and include 20 digits.',
        patient_email_placeholder: 'Patient email for password reset and terms of use',
        patient_phone_placeholder: 'Phone number',
        patient_address_placeholder: 'Patient address for delivery',
        patient_pharmacy_placeholder: 'Select Pharmacy',

        notification_message_delete: 'Are you sure you want to delete this patient?',
        notification_message_resend: 'Do you want to send a temporary password to this patient?',
        notification_language: 'Notification Language',
        notification_language_placeholder: 'Select language',
        shop_type_placeholder: 'Select Shop Type',
        shop_type: 'Shop Type',

        english: 'English',
        deutsch: 'Deutsch',
        french: 'French',
        italian: 'Italian',

        /* Strings for new release */
        choose_pricing_mode: 'Select the pricing mode for this pharmacy',
        pricingOptions: ['PPP', 'Parent company', 'This pharmacy', 'No price list'],
        no_pricing_file: 'No pricing file currently uploaded for this pharmacy',
        download_prices: 'Download current price',
        set_pricing_mode: 'Set pricing mode:',
        set_pharmacy_prices: 'Set Pharmacy product prices',
        prices_saved: 'Pricing options saved successfully',
        set_company_prices: 'Set Company product prices',
        overwrite_prices: 'Replace entire current price list',

        paid_on_delivery: "Pay on pickup / delivery",
        paid_card: "Credit Card",
        paid_paypal: "Paypal Account",
        order_total: "Order Total",

        delivery: "Delivery",
        method_of_payment: "Method of payment",
        at_home: "at Home",
        with_courier: "with Courier",
        in_pharmacy: "in Pharmacy",

    },
    de: {
        login: 'Einloggen',
        logout: 'Ausloggen',
        password: 'Passwort',
        password_forgotten: 'Passwort vergessen?',
        forgotten_password: 'Vergessenes Passwort',
        reset_success: 'Ihr Passwort wurde zurückgesetzt.',
        resend_password: 'Passwort erneut senden',
        keep_me: 'Eingeloggt bleiben',
        click_here: 'Klicken Sie hier.',

        provide_email_and_password: 'Bitte geben Sie eine E-Mail und ein Passwort ein.',
        provide_email: 'Bitte geben Sie eine E-Mail ein.',
        provide_password: 'Bitte geben Sie ein Passwort ein.',
        provide_valid_email: 'Geben Sie bitte eine gültige E-Mail ein.',
        invalid_username_password: 'Ungültiger Benutzernamen und/oder Passwort Kombination.',
        invalid_user_credentials: 'Ungültige Benutzeranmeldeinformationen',

        email: 'E-mail',
        Email: 'E-mail',
        emailCourier: 'E-mail',
        check_email: 'Sie erhalten in Kürze eine E-Mail mit einem Link.',
        enter_email: 'Geben Sie die E-Mail ein.',
        send: 'Senden',
        resend: 'Erneut senden',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        HELP: 'HILFE',
        Save: 'Speichern',

        Role: 'Rolle',
        role_select_placeholder: 'Inhaber, Manager oder Mitarbeiter wählen',
        ADMIN: 'Site Admin',
        ROLE_OWNER: 'Store-Inhaber',
        ROLE_MANAGER: 'Apotheke Manager',
        ROLE_PHARMACIST: 'Apotheker',

        USER: 'Benutzer',
        Users: 'Benutzer',
        users_description: 'Neue Benutzer hinzufügen oder editieren.',
        user_info: 'Benutzerinfo',
        Add_new_user: 'Neuen Benutzer hinzufügen',

        Company: 'Firma',
        Companies: 'Firmen',
        companies_description: 'Neue Firma hinzufügen oder editieren',
        add_company: 'Firma Hinzufügen',
        add_new_company: 'Eine neue Firma eingeben.',
        create_company: 'Firma erfassen', //translation modified
        save_company: 'Firma Speichern',
        edit_company: 'Firma bearbeiten',
        select_company: 'Firma auswählen',
        company_info: 'Firmen Info',
        company_name: 'Firmen Name',
        company_owner: 'Firmeninhaber',
        select_company_owner: 'Firmeninhaber wählen',

        Pharmacy: 'Apotheke',
        Pharmacies: 'Apotheken',
        Pharmacy_name: 'Apotheken Name',
        Pharmacy_info: 'Apothekeninfo',
        Pharmacy_description: 'Ihre Apotheke hinzufügen, editieren oder löschen. Bearbeiten Sie das Design und die Services.',
        Add_Pharmacy: 'Apotheke hinzufügen',
        Add_new_pharmacy: 'Neue Apotheke hinzufügen',
        Edit_pharmacy: 'Apotheke editieren',
        Enter_pharmacy_name: 'Apotheken Name eingeben',
        Select_pharmacy: 'Apotheke wählen',
        pharmacy_manager: 'Apotheke Manager',
        select_pharmacy_manager: 'Apotheke Manager wählen',
        pharmacies_owned: 'Anzahl der Apotheken',
        pharmacy_count: 'Apothekenanzahl',

        Services: 'Dienstleistungen',
        Add_Services: 'Service hinzufügen',
        Add_pharmacy_service: 'Apotheken Service hinzufügen',
        Edit_pharmacy_service: 'Apotheken Service editieren',
        Add_service_name: 'Service Namen eingeben',
        Add_service_name_placeholder: 'Service Namen für die Listenansicht eingeben',
        Add_service_title: 'Service Titel eingeben',
        Service_title: 'Service Titel',
        Service_description: 'Service Beschreibung',
        service_language: 'Service-Sprache',
        service_language_placeholder: 'Service-Sprache auswählen',

        Link_to_iFrame: 'Link zum iFrame',
        Link_to_iFrame_placeholder: 'Dieser Link ist zu Ihrem iFrame (optional)',
        Link_to_service: 'Link zum Service',
        Link_to_service_placeholder: 'Dieser Link führt zu Ihrer Seite (optional)',

        Name: 'Name',
        nameCourier: 'Name',
        name: 'Name',
        address: 'Adresse',
        City: 'Stadt',
        phone: 'Telefon',
        phone_number: 'Telefonnummer',
        Category: 'Category',
        insurance_card: 'Versicherungskarte',
        insuranceCard: 'Versicherungskarte',
        insuranceCardCourier: 'Insurance card',
        Insurance_card: 'Versicherungskarte (optional)',
        Second_insurance_card: 'Zweite Versicherungskarte (optional)',
        insurance_card_photos: 'Bilder der Versicherungskarte',
        second_insurance_card_photos: 'Bilder der zweiten Versicherungskarte',
        insurance_card_images: 'Bilder von Versicherungskarte', //translation modified
        no_insurance_card_info: 'keine Versicherungsinformationen vorhanden',
        Primary_card: 'Erste Versicherungsnummer',
        Secondary_card: 'Zweite Versicherungsnummer',
        web_address: 'Webseite Adresse',
        web_site_placeholder: 'Webseite URL eingeben',
        instruction_url: 'Instruction URL',
        instruction_url_placeholder: 'Enter instruction url',
        Drugstore: 'Drogerien',
        primary_info: 'Primärinformationen',
        design: 'Design',
        offering: 'Angebot',
        delivery_option: 'Lieferoption',
        contact: 'Kontakt',

        Order: 'Bestellung',
        Orders: 'Bestellungen',
        All_Orders: 'Alle Bestellungen',
        Orders_description: 'Bearbeiten oder löschen Sie Ihre Bestellungen.',
        Orders_email: 'E-Mail für Bestellungen (HIN)',
        Orders_subscription: 'Bestellungen an alle Mitarbeitern senden.',
        order_number: 'Bestell-Nummer',
        order_address: 'Bestelladresse',
        order_status: 'Bestellstatus',
        Pending_Orders: 'Offene Bestellungen',
        pending_order: 'Ausstehende Bestellungen',
        Accepted_Orders: 'Angenommene Bestellungen',
        accept_order: 'Bestellung annehmen',
        Active_Orders: 'Aktive Bestellungen',
        Ready_Orders: 'Fertige Bestellungen',
        order_ready: 'Bestellung fertiggestellt',
        Canceled_Orders: 'Abgebrochene Bestellungen',
        cancel_order: 'Bestellung abbrechen',
        delete_order: 'Delete Order',
        Closed_Orders: 'Abgeschlossene Bestellungen',
        orders_delivered: 'Abgeschlossene Bestellungen',

        Patients: 'Kunden', //translation needed
        Patients_description: 'Liste, Kunden erstellen und hinzufügen.',

        Statistics: 'Statistik',
        Statistics_description: 'Sehen Sie die Anzahl der Bestellungen und wie lange die Bearbeitungszeiten sind.',
        Response_Time: 'Antwortzeit',
        Filter_by_status: 'Nach Status filtern',

        owner: 'Besitzer',
        employees: 'Angestellte',
        Manager: 'Manager',

        Add_description: 'Beschreibung eingeben',
        Add_picture: 'Bild hinzufügen',
        Learn_more: 'Mehr erfahren',
        see_details: 'Details anzeigen',
        view_images: 'Bilder anzeigen',
        preview_image: 'Bild Vorschau',
        show_per_page: 'Anzahl {num} pro Seite anzeigen',
        first: 'erste',
        last: 'letzte',
        back: 'Zurück',
        reset: 'Zurücksetzen',
        yes: 'Ja',
        no: 'Nein',
        Photos: 'Fotos',
        front_side: 'Vorderseite',
        back_side: 'Rückseite',
        image_front: 'Vorderseite',
        image_back: 'Rückseite',
        choose_search_criteria: 'Wählen Sie ein Suchkriterium um einen Kunden hinzuzufügen',
        search_by_name: 'Nach Namen suchen',
        search_post_code_address: 'Suche nach Name, Postleitzahl oder Straßenadresse',
        search_by_email: 'Nach E-Mail suchen',
        search_by_insurance_card: 'Nach Versicherungsnummer suchen',
        no_results_found: 'Keine Ergebnisse gefunden',
        something_went_wrong: 'Es ist ein Fehler aufgetreten!',
        error: 'Fehler',
        not_empty_error: 'Diese Eingabe sollte nicht leer sein.',
        add: 'Hinzufügen',
        not_set: 'Keine Angabe',  //translation needed
        active: 'Aktiv', //translation modified

        no_email_set: 'Es wurde keine E-Mail angegeben.',
        no_owner_set: 'Es wurde kein Besitzer angegeben.',
        enter_valid_address: 'Bitte eine gültige E-Mail angeben.',
        mailing_purposes_only: 'Diese E-Mail wird für Kontakt Zwecke genutzt, falls nötig.',
        search_places: 'Ort suchen.',
        select_address_from_suggest_list: 'Bitte wählen Sie eine Adresse aus den Vorschlägen.',
        select_address_from_suggest_list_edit: 'Wenn Sie die Adresse ändern möchten, wählen Sie diese aus der Liste.',
        work_phone: 'Telefon Geschäft',

        client_name: 'Name des Kunden',
        date_received: 'Empfangen am',
        date_completed: 'Erledigt am',
        registered_on: 'Registriert auf',

        medication: 'Medikamente',
        medication_name: 'Artikelname',
        quantity: 'Anz.',
        amount_label: 'Menge',
        quantity_label: 'Anzahl',
        package_size_label: 'Packungsgrösse',
        package_type: 'Art der Packung',
        package_size: 'Packungsgrösse',
        box: 'Box',
        blister: 'Blister',
        bottle: 'Flasche',
        sachet: 'Beutel',
        ampoule: 'Ampulle',
        pack: 'Packung',
        Notes: 'Notizen',
        Pharmacist: 'Apotheker',
        Druggist: 'Drogist',
        Received: 'Erhalten',
        Read: 'Gelesen',
        Taken: 'Angenommen',
        Sent: 'Gesendet',
        on: 'on',
        write_a_msg: 'Schreiben Sie dem Kunden eine Nachricht.',
        change_status: 'Status ändern',
        change_status_to: 'Status ändern auf: ',
        delete_order_msg: 'Are you sure you want to delete this order?',
        delete_order_info: 'Order status must be Ready or Cancelled to be able to delete the order.',
        order_is_deleted: 'Order is deleted',

        insurance_card_warning_1: 'This value must start with "8075".',  //Translation needed we disabeled this warnings
        insurance_card_warning_2: 'This value must start with "8075" and have exactly 20 digits.',  //Translation needed we disabeled this warnings
        insurance_card_warning_3: 'This value should have exactly 20 digits.',  //Translation needed we disabeled this warnings
        please_select_a_date: 'Bitte wählen Sie ein Datum.',

        Shop: 'Shop',  //translation modified
        Shop_url: 'Shop Link',  //translation modified
        shop_input_placeholder: 'Geben Sie einen gültigen Link ein.',
        Save_shop_url: 'Shop Link speichern',

        Merchant_id: 'Merchant Id',
        Merchant_id_input_placeholder: 'Enter a valid Merchant Id.',

        Edit_payment: 'Edit Payment',
        Save_edit_payment: 'Save',

        Public_key: 'Public Key',
        Public_key_input_placeholder: 'Enter a valid link to your Public Key.',

        Private_key: 'Private Key',
        Private_key_input_placeholder: 'Enter a valid Private Key.',

        Background: 'Hintergrund',
        Backdrop: 'Hintergrundfarbe',
        Optimal_size: 'Die optimale Bildgrösse ist {width}x{height} px.',
        use_png: 'Bitte benutzen Sie nur .png Bilder',
        Logo: 'Logo',
        Text_color: 'Text Farbe',
        Opacity: 'Hintergrunddeckkraft',
        Scale: "Logo Skala",
        Gradient: 'Hintergrundverlauf',
        Solid: 'Einfarbig',
        Opening_hours_today: 'Öffnungszeiten (heute)',
        to: 'bis',
        and: 'und',
        My_medications: 'Meine Medikamente',
        Contacts: 'Kontakte',

        Work_time_editor: 'Bearbeitung der Öffnungszeiten',
        Work_time: 'Öffnungszeiten',
        Work_time_language: 'Sprache der Arbeitszeit',
        Day: 'Tag',
        Date: 'Datum',
        Add_date: 'Datum hinzufügen',
        Work_from: 'Offen von',
        Work_to: 'Offen bis',
        Day_Off: 'Geschl', // "Geschlossen"
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        areas_of_delivery_time: 'Lieferradius und Lieferzeiten',
        separate_areas_with_comma: 'Kommagetrennt aufzählen',
        Lunch_Break: 'Pause', //translation modified
        Special_work_time: 'Spezielle Öffnungszeiten',
        work_time_tab: 'Öffnungszeiten',
        special_days_tab: 'Spezielle Öffnungszeiten',
        national_holidays_tab: 'Nationalfeiertage',
        holiday: 'Feiertag',
        enter_name: 'Name eingeben (optional)',
        Pick_a_date: 'Wählen Sie ein Datum',
        areas_of_delivery_text_en: '*Our pharmacy delivers in standard work time and in the entire city.',  //translation modified
        areas_of_delivery_text_de: '*Unsere Apotheke bietet den Hauslieferdienst in der ganzen Stadt an.',  //translation modified
        areas_of_delivery_text_fr: '*Notre pharmacie livre dans toute la localité, durant les heures d\'ouverture.',  //translation modified
        areas_of_delivery_text_it: '*Our pharmacy delivers in standard work time and in the entire city.',  //translation modified

        disable_home_delivery: 'Lieferung deaktivieren',
        has_services: 'Has Services',
        disable_delivery_by_courier: 'Disable delivery by courier.',
        customer_white_list_editor: 'Bearbeitung Kundenliste für Lieferung',
        customer_white_list: 'Kundenliste für Lieferung',
        change_white_list_warning: 'Die Änderungen werden sofort übernommen. Fortfahren?',

        Add_user: 'Benutzer hinzufügen',
        Save_user: 'Benutzer speichern',
        Edit_User: 'Benutzer editieren',
        Edit_Password: 'Passwort editieren',
        User_Full_name: 'Vollständiger Name des Benutzers',
        user_email_placeholder: 'nur zur Überprüfung und Anmeldung',

        Add_new_patient: 'Neuen Kunden hinzufügen', //translation modified
        Create_patient: 'Kunden erstellen', //translation modified
        Edit_patient: 'Kunden editieren',  //translation modified
        edit_patient: 'Kunden editieren',  //translation modified
        delete_patient: 'Kunden löschen',  //translation modified
        Patient_info: 'Kundeninfo',  //translation modified
        Birthday: 'Geburtstag',
        print_QR_code: 'QR-Code drucken',
        generate_QR_code: 'QR-CODE erzeugen',
        scan_QR_code: 'QR-Code scannen',
        patient_name: 'Name des Kunden',  //translation modified
        patient_name_placeholder: 'Name des Kunden',    //translation modified
        patient_birthday_placeholder: 'Geburtsdatum wählen oder schreiben (z.B. 14/05/1992)',
        patient_insurance_card: 'Erste Versicherungsnummer',
        patient_insurance_card_2: 'Zweite Versicherungsnummer',
        patient_insurance_card_placeholder: 'Erste Versicherungsnummer',
        patient_insurance_card_2_placeholder: 'Zweite Versicherungsnummer',
        patient_email_placeholder: 'Kunden E-Mail für Passwort-Reset und Nutzungsbedingungen',  //translation modified
        patient_phone_placeholder: 'Telefonnummer',
        patient_address_placeholder: 'Kundenadresse für die Lieferung',  //translation modified
        patient_pharmacy_placeholder: 'Apotheke wählen',

        notification_message_delete: 'Sind Sie sicher, dass Sie diesen Kunden löschen möchten?',  //translation modified
        notification_message_resend: 'Möchten Sie diesem Kunden ein temporäres Passwort senden?',  //translation modified
        notification_language: 'Benachrichtigungssprache',
        notification_language_placeholder: 'Sprache auswählen',
        shop_type_placeholder: 'Select Shop Type',
        shop_type: 'Shop Type',

        english: 'Englisch',
        deutsch: 'Deutsch',
        french: 'Französisch',
        italian: 'Italienisch',
        /* TRANSLATION NEEDED */
        choose_pricing_mode: 'Wählen Sie die Preisliste für diese Apotheke',
        pricingOptions: ['PPP', 'Eigenes Unternehmen', 'Diese Apotheke', 'Keine Preisliste'],
        no_pricing_file: 'Aktuell keine Preisliste hinterlegt',
        download_prices: 'Aktuelle Preisliste downloaden',
        set_pricing_mode: 'Liste auswählen:',
        set_pharmacy_prices: 'Preisliste für die Apotheke auswählen',
        prices_saved: 'Preis Option erfolgreich gespeichert',
        set_company_prices: 'Unternehmenspreise festlegen',
        overwrite_prices: 'Liste komplett ersetzen'
    },
    fr: {
        login: 'Connexion',
        logout: 'Déconnexion',
        password: 'mot de passe',
        password_forgotten: 'Mot de passe oublié ?',
        forgotten_password: 'Mot de passe oublié',
        reset_success: 'Votre mot de passe a été réinitialisé',
        resend_password: 'Mot de passe envoyé à nouveau',
        keep_me: 'Rester connecté',
        click_here: 'Cliquez ici.',

        provide_email_and_password: 'Veuillez indiquer votre e-mail et votre mot de passe.',
        provide_email: 'Veuillez indiquer votre e-mail.',
        provide_password: 'Veuillez indiquer votre mot de passe.',
        provide_valid_email: 'Veuillez indiquer un e-mail valide.',
        invalid_username_password: "Combinaison nom d'utilisateur / mot de passe invalide.",
        invalid_user_credentials: "Données d'identification invalides",

        email: 'E-mail',
        Email: 'E-mail',
        emailCourier: 'E-mail',
        check_email: 'Contrôlez votre boîte mail dans quelques minutes pour un lien de récupération',
        enter_email: 'Entrez votre e-mail',
        send: 'Envoyer',
        resend: 'Envoyer à nouveau',
        cancel: 'Interrompre',
        delete: 'Effacer',
        HELP: 'AIDE',
        Save: 'enregistrer',

        Role: 'Fonction',
        role_select_placeholder: 'Sélectionner propriétaire, gérant ou employé',
        ADMIN: 'Site Admin',
        ROLE_OWNER: 'Enregistrer le propriétaire',
        ROLE_MANAGER: 'Gérant de la pharmacie',
        ROLE_PHARMACIST: 'Pharmacien',

        USER: 'UTILISATEUR',
        Users: 'Utilisateurs',
        users_description: 'Ajouter des nouveaux utilisateurs ou éditer la liste des utilisateurs et des autorisations',
        user_info: 'Infos utilisateur',
        Add_new_user: 'Ajouter un nouvel utilisateur',

        Company: 'Société',
        Companies: 'Sociétés',
        companies_description: 'Ajouter une nouvelle société ou éditer la liste des sociétés',
        add_company: 'Ajouter une entreprise',
        add_new_company: 'Ajouter une nouvelle société.',
        create_company: 'Créer une entreprise',
        save_company: "Enregistrer l'entreprise",
        edit_company: 'Editer la société',
        select_company: 'Choisir la société',
        company_info: 'Info société',
        company_name: 'Nom de la société',
        company_owner: "Propriétaire de l'entreprise",
        select_company_owner: "Sélectionner le propriétaire de l'entreprise",

        Pharmacy: 'Pharmacie',
        Pharmacies: 'Pharmacies',
        Pharmacy_name: 'Nom de la pharmacie',
        Pharmacy_info: 'Info pharmacie',
        Pharmacy_description: "Ajouter, éditer ou supprimer l'une de vos pharmacies. Personnaliser la présentation et les services.",
        Add_Pharmacy: 'Ajouter une pharmacie',
        Add_new_pharmacy: 'Ajouter une nouvelle pharmacie',
        Edit_pharmacy: 'Editer la pharmacie',
        Enter_pharmacy_name: 'Entrer le nom de la pharmacie',
        Select_pharmacy: 'Sélectionner la pharmacie',
        pharmacy_manager: 'Gérant de la pharmacie',
        select_pharmacy_manager: 'Sélectionner le gérant de la pharmacie',
        pharmacies_owned: 'Pharmacies possédées',
        pharmacy_count: 'Nombre de pharmacies',

        Services: 'Services',
        Add_Services: 'Ajouter des services',
        Add_pharmacy_service: 'Ajouter des services de la pharmacie',
        Edit_pharmacy_service: 'Editer le service de la pharmacie',
        Add_service_name: 'Indiquer le nom du service',
        Add_service_name_placeholder: 'Nom du service sur la liste',
        Add_service_title: 'Ajouter le nom du service',
        Service_title: 'Titre du service',
        Service_description: 'Description du service',
        service_language: 'Langue de service',
        service_language_placeholder: 'Sélectionner la langue de service',

        Link_to_iFrame: 'Lien  vers iFrame',
        Link_to_iFrame_placeholder: "Il s'agit du lien vers votre iFrame (facultative)",
        Link_to_service: 'Lien vers le service',
        Link_to_service_placeholder: "Il 'agit du lien vers votre page (facultative)",

        Name: 'Nom',
        nameCourier: 'Name',
        name: 'Nom',
        address: 'Adresse',
        City: 'Localité',
        phone: 'Téléphone',
        phone_number: 'Numéro de téléphone',
        Category: 'Category',
        insurance_card: "Carte d'assuré",
        insuranceCard: "Carte d'assuré",
        insuranceCardCourier: 'Insurance card',
        Insurance_card: "Carte d'assuré (optionnel)",
        Second_insurance_card: "Deuxième carte d'assuré (facultative)",
        insurance_card_photos: "Photos de la carte d'assuré",
        second_insurance_card_photos: "Photos de la deuxième carte d'assuré",
        insurance_card_images: "Photos de la carte d'assuré",
        no_insurance_card_info: "Pas d'information sur la carte d'assuré",
        Primary_card: "Premier numéro d'assuré",
        Secondary_card: "Deuxième numéro d'assuré",
        web_address: 'Adresse web',
        web_site_placeholder: "Entrer l'adresse web",
        instruction_url: 'Instruction URL',
        instruction_url_placeholder: 'Enter instruction url',
        Drugstore: 'Pharmacie',
        primary_info: 'Informations principales',
        design: 'Conception',
        offering: 'Offre',
        delivery_option: 'Option de livraison',
        contact: 'Contact',

        Order: 'Commande',
        Orders: 'Commandes',
        All_Orders: 'Toutes les commandes ',
        Orders_description: 'Editez ou effacez vos commandes',
        Orders_email: 'E-mail pour les commandes',
        Orders_subscription: 'Send orders to all employees.',
        order_number: 'numéro de commande',
        order_address: 'Adresse de la commande',
        order_status: 'Etat de la commande',
        Pending_Orders: 'Commandes ouvertes',
        pending_order: 'Commandes ouvertes',
        Accepted_Orders: 'Commandes acceptées',
        accept_order: 'Accepter la commande',
        Active_Orders: 'Commandes actives',
        Ready_Orders: 'Commandes prêtes',
        order_ready: 'Commande prête',
        Canceled_Orders: 'Commandes annulées',
        cancel_order: 'Interrompre la commande',
        delete_order: 'Delete Order',
        Closed_Orders: 'Commandes exécutées',
        orders_delivered: 'Commandes délivrées',

        Patients: 'Patients',
        Patients_description: 'Lister, créer, éditer des patients',

        Statistics: 'Statistiques',
        Statistics_description: 'Visualisez la performance de chaque pharmacie, leur nombre de commande et les temps de traitement.',
        Response_Time: 'Temps de réponse',
        Filter_by_status: "Filtrer selon l'état",

        owner: 'Propriétaire',
        employees: 'Employés',
        Manager: 'Manager',

        Add_description: 'Ajouter la description',
        Add_picture: 'Ajouter une image',
        Learn_more: 'En savoir plus',
        see_details: 'Afficher les détails',
        view_images: 'voir images',
        preview_image: "Prévisualisation de l'image",
        show_per_page: 'Afficher {num} par page',
        first: 'premier',
        last: 'dernier',
        back: 'Retour',
        reset: 'réinitialiser',
        yes: 'Oui',
        no: 'Non',
        Photos: 'Photos',
        front_side: 'Face avant',
        back_side: 'Face arrière',
        image_front: 'avant',
        image_back: 'arrière',
        choose_search_criteria: 'Choisir les critères de recherche pour ajouter un client',
        search_by_name: 'Recherche par nom',
        search_post_code_address: 'Rechercher par nom, code postal ou adresse',
        search_by_email: 'Recherche par e.mail',
        search_by_insurance_card: "Recherche par carte d'assuré",
        no_results_found: 'Aucun résultat trouvé',
        something_went_wrong: "Une erreur s'est produite !",
        error: 'Erreur',
        not_empty_error: 'Cette entrée ne doit pas être vide',
        add: 'Ajouter',
        not_set: 'Non défini',
        active: 'Actif',

        no_email_set: "Pas d'e-mail indiqué",
        no_owner_set: 'Pas de propriétaire indiqué',
        enter_valid_address: 'Veuillez indiquer un e-mail valide.',
        mailing_purposes_only: 'Cette adresse mail sera utilisée pour vous contacter si nécessaire.',
        search_places: 'Chercher localité',
        select_address_from_suggest_list: 'veuillez choisir une adresse parmi les propositions.',
        select_address_from_suggest_list_edit: 'Si vous souhaitez changer votre adresse, veuillez choisir dans la liste.',
        work_phone: 'Téléphone professionnel',

        client_name: 'Nom du client',
        date_received: 'Date de réception',
        date_completed: 'Date de fin de traitement',
        registered_on: 'enregistrée sur',

        medication: 'Médicaments',
        medication_name: 'Nom de l\'article',
        quantity: 'Quant.',
        amount_label: 'Montant',
        quantity_label: 'Quantité',
        package_size_label: 'La taille de l\'emballage',
        package_type: 'Type de Emballage',
        package_size: 'La taille de l\'emballage',
        box: 'Boîte',
        blister: 'Blister',
        bottle: 'Bouteille',
        sachet: 'Sachet',
        ampoule: 'Ampoule',
        pack: 'Emballage',
        Notes: 'Notes',
        Pharmacist: 'Pharmacien',
        Druggist: 'Pharmacienne',
        Received: 'Reçu',
        Read: 'Lu',
        Taken: 'Accepté',
        Sent: 'Envoyé',
        on: 'ouvert',
        write_a_msg: 'Ecrire un message que le client recevra.',
        change_status: 'Changer le statut',
        change_status_to: 'Changer le statut en: ',
        delete_order_msg: 'Are you sure you want to delete this order?',
        delete_order_info: 'Order status must be Ready or Cancelled to be able to delete the order.',
        order_is_deleted: 'Order is deleted',

        insurance_card_warning_1: 'Cette valeur doit commerncer par "8075".',
        insurance_card_warning_2: 'Cette valeur doit commerncer par "8075" et comporter exactement 20 chiffres.',
        insurance_card_warning_3: 'Cette valeur doit comporter exactement 20 chiffres.',
        please_select_a_date: 'Veuillez choisir une date.',

        Shop: 'Boutique',
        Shop_url: 'URL de la boutique',
        shop_input_placeholder: 'Entrez un lien valide vers votre boutique',
        Save_shop_url: 'Enregistrer le lien vers la boutique',

        Merchant_id: 'Merchant Id',
        Merchant_id_input_placeholder: 'Enter a valid Merchant Id.',

        Edit_payment: 'Edit Payment',
        Save_edit_payment: 'Save',

        Public_key: 'Public Key',
        Public_key_input_placeholder: 'Enter a valid link to your Public Key.',

        Private_key: 'Private Key',
        Private_key_input_placeholder: 'Enter a valid Private Key.',

        Background: 'Arrière-plan',
        Backdrop: 'Couleur de fond',
        Optimal_size: 'La taille optimale des images est de {width}x{height} px.',
        use_png: "Veuillez n'utiliser que des images .png",
        Logo: 'Logo',
        Text_color: 'Couleur du texte',
        Opacity: "Opacité de l'arrière-plan",
        Scale: "Échelle du logo",
        Gradient: "Dégradé d'arrière-plan",
        Solid: 'Unicolore',
        Opening_hours_today: "Heures d'ouverture aujourd'hui",
        to: 'de',
        and: 'et ',
        My_medications: 'Mes médicaments',
        Contacts: 'Contacts',

        Work_time_editor: "Editeur des heures d'ouverture",
        Work_time: "Horaire d'ouverture",
        Work_time_language: 'Langue de travail',
        Day: 'Jour',
        Add_date: 'Ajouter une date',
        Date: 'Date',
        Work_from: 'Ouvert de',
        Work_to: 'Ouvert à',
        Day_Off: 'Jour de fermeture',
        monday: 'lundi',
        tuesday: 'mardi',
        wednesday: 'mercredi',
        thursday: 'jeudi',
        friday: 'vendredi',
        saturday: 'samedi',
        sunday: 'dimanche',
        areas_of_delivery_time: 'zob',
        separate_areas_with_comma: 'Zones et horaires de livraison',
        Lunch_Break: 'Break',
        Special_work_time: "Heures d'ouverture spéciales",
        work_time_tab: "Horaire d'ouverture",
        special_days_tab: 'Jours spéciaux',
        national_holidays_tab: 'Jours fériés',
        holiday: 'Vacances',
        enter_name: 'Entrer un nom (facultatif)',
        Pick_a_date: 'Sélectionnez une date',
        areas_of_delivery_text_en: 'Our pharmacy delivers in standard work time and in the entire city.',
        areas_of_delivery_text_de: 'Unser Apotheke bietet den Hauslieferdienst in der ganzen Stadt an.',
        areas_of_delivery_text_fr: 'Notre pharmacie livre dans toute la localité, durant les heures d\'ouverture.',
        areas_of_delivery_text_it: 'Our pharmacy delivers in standard work time and in the entire city.',

        disable_home_delivery: 'Désactiver la livraison à domicile',
        has_services: 'Has Services',
        disable_delivery_by_courier: 'Disable delivery by courier.',
        customer_white_list_editor: 'Editeur de la liste blanche de clients',
        customer_white_list: 'Liste blanche des clients',
        change_white_list_warning: 'Les modifications prendront effet immédiatement. Voulez-vous continuer?',

        Add_user: 'Ajouter un utilisateur',
        Save_user: "Sauvegarder l'utilisateur",
        Edit_User: "Editer l'utilisateur",
        Edit_Password: 'Editer le mot de passe',
        User_Full_name: 'Utiliser le nom complet',
        user_email_placeholder: 'Utilisé uniquement pour la vérification et la connexion',

        Add_new_patient: 'Ajouter un nouveau patient',
        Create_patient: 'Créer un patient',
        Edit_patient: 'Editer un patient',
        edit_patient: 'Editer un patient',
        delete_patient: 'Supprimer un patient',
        Patient_info: 'Information patient',
        Birthday: 'Anniversaire',
        print_QR_code: 'Imprimer le code QR',
        generate_QR_code: 'Générer le code QR',
        scan_QR_code: 'Scanner le code QR',
        patient_name: 'Nom du patient',
        patient_name_placeholder: 'Nom du patient',
        patient_birthday_placeholder: 'Choisir ou écrire la date (p. ex. 14/05/1992)',
        patient_insurance_card: "Premier numéro d'assuré",
        patient_insurance_card_2: "Deuxième numéro d'assuré",
        patient_insurance_card_placeholder: 'Entrer un numéro de carte commençant par "8075" et comportant 20 chiffres.',
        patient_insurance_card_2_placeholder: 'Entrer un numéro de carte commençant par "8075" et comportant 20 chiffres.',
        patient_email_placeholder: "E-mail du patient pour réinitialisation du mot passe et conditions d'utilisation",
        patient_phone_placeholder: 'Numéro de téléphone',
        patient_address_placeholder: 'Adresse du patient pour livraison',
        patient_pharmacy_placeholder: 'Sélectionner la pharmacie',

        notification_message_delete: 'Etes-vous sûr de vouloir supprimer ce patient?',
        notification_message_resend: 'Voulez-vous envoyer un mot de passe temporaire à ce patient?',
        notification_language: 'Notifiction de la langue',
        notification_language_placeholder: 'Sélection de la langue',
        shop_type_placeholder: 'Select Shop Type',
        shop_type: 'Shop Type',

        english: 'Anglais',
        deutsch: 'Allemand',
        french: 'Français',
        italian: 'Italien',
        /* TRANSLATION NEEDED */
        choose_pricing_mode: 'Sélectionnez le mode de tarification pour cette pharmacie',
        pricingOptions: ['PPP', 'Maison-mère', 'Cette pharmacie', 'Pas de liste de prix'],
        no_pricing_file: 'Pour l’instant, aucun fichier de tarification n’a été téléchargé pour cette pharmacie',
        download_prices: 'Télécharger le tarif actuel',
        set_pricing_mode: 'Définir le mode de tarification:',
        set_pharmacy_prices: 'Définir les prix des produits de la pharmacie',
        prices_saved: 'Les options de tarification ont été enregistrées avec succès',
        set_company_prices: 'Définir les prix des produits de l’entreprise',
        overwrite_prices: 'Remplacer complètement la liste'
    }
};



// WEBPACK FOOTER //
// ./src/customModules/Common/Translations.js